import React from 'react'

import * as S from './styles'

import IProps from './props'

const ConfirmContract = ({ invertColor, handleContract }: IProps) => (
  <S.Container>
    <S.ConfirmationText invertColor={invertColor}>
      <span>Caso tenha contratado este médico, </span>
      nos informe clicando no botão abaixo:
    </S.ConfirmationText>
    <S.ConfirmButton invertColor={invertColor} onClick={handleContract}>
      Contratamos este médico
    </S.ConfirmButton>
  </S.Container>
)

ConfirmContract.defaultProps = {
  invertColor: false,
}

export default ConfirmContract
